import { Typography, Box } from '@mui/material'
import { useState } from 'react'
import LockerAcessHistoryListTable from './LockerAccessHistoryTable';
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';

const LockerAccessHistoryManagement = () => {
  const [lockerAccessHistoryList, setLockerAccessHistoryList] = useState<any | null>()
  const [loading, setLoading] = useState<boolean>(false);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [skip, setSkip] = useState(0)
  const [count, setCount] = useState<any>(0);
  const [take, setTake] = useState(10)

  const { get } = useCrudForm();

  const refetchData = ({ fromDate, toDate, name, lockerNumber, location }: { fromDate?: any, toDate?: any, name?: any, lockerNumber?: any, location?: any }) => {
    get({
      endpoints: endpoints.lockerAccessHistory.list({ fromDate, toDate, name, location, lockerNumber, skip: skip * take, take }),
      onSuccess: (data: any) => {
        setLockerAccessHistoryList(data.data.list)
        setCount(data.data.count)
        setLoading(false)
        setButtonLoading(false)
      },
      onError: (error: any) => {
        console.log(error)
        setLoading(false)
        setButtonLoading(false)
      }
    })
  }

  return (
    <>
      <Typography variant="h5" component="h5" mb={1} fontWeight={600}>Locker Access History Management</Typography>
      <Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>
        <LockerAcessHistoryListTable refetchData={refetchData} loading={loading} setLoading={setLoading} buttonLoading={buttonLoading} setButtonLoading={setButtonLoading} skip={skip} take={take} setTake={setTake} setSkip={setSkip} count={count} rows={lockerAccessHistoryList} />
      </Box>
    </>
  )
}

export default LockerAccessHistoryManagement
